import { render } from "./ExhibitionDesignPicker.vue?vue&type=template&id=22cf196a&scoped=true"
import script from "./ExhibitionDesignPicker.vue?vue&type=script&lang=js"
export * from "./ExhibitionDesignPicker.vue?vue&type=script&lang=js"

import "./ExhibitionDesignPicker.vue?vue&type=style&index=0&id=22cf196a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cf196a"]])

export default __exports__